// removed by extract-text-webpack-plugin
module.exports = {"controls":"editable-order__controls-1PfBO"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/editable-order/editable-order.css
// module id = 758
// module chunks = 0